import React, { useEffect, useState } from 'react';
import { useAppStateApartmentCompareListStore } from '../../../../common/store/AppStateStore.zustand';
import { useApartmentCompareAPI } from '../../api/ApartmentCompare.api';
import { ApartmentCompare } from '../../type/ApartmentCompare.type';

export interface EditApartmentModalData {
  isOpen: boolean;
  apartmentCompare: ApartmentCompare;
  onClose: () => void;
}

const EditApartmentModal = ({ isOpen, apartmentCompare, onClose }: EditApartmentModalData) => {
  const { updateApartmentCompare, getApartmentCompareList } = useApartmentCompareAPI();
  const { setApartmentCompareList } = useAppStateApartmentCompareListStore();
  const [displayName, setDisplayName] = useState('');

  useEffect(() => {
    setDisplayName(apartmentCompare.name);
  }, [isOpen, apartmentCompare]);

  const handleSave = async () => {
    if (!displayName.trim()) return;
    await updateApartmentCompare({ ...apartmentCompare, name: displayName.trim() });
    const { data } = await getApartmentCompareList();
    setApartmentCompareList(data);
    onClose();
  };

  if (!isOpen) return <></>;

  return (
    <div className="fixed h-screen inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
      <div className="bg-white rounded-lg w-[480px] shadow-xl">
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold text-gray-800">아파트 수정</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div className="p-6 space-y-4">
          <div className="bg-gray-50 rounded-lg p-3">
            <p className="text-sm text-gray-600">{apartmentCompare.sidoName} {apartmentCompare.sigunguName}</p>
            <p className="font-medium text-gray-800">{apartmentCompare.aptName} {apartmentCompare.excluUseAr}㎡</p>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">표시명</label>
            <input
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-indigo-500 transition-colors"
            />
          </div>
        </div>
        <div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 !rounded-button"
          >
            취소
          </button>
          <button
            disabled={!displayName.trim()}
            onClick={handleSave}
            className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-4 py-2 rounded-md text-sm !rounded-button"
          >
            저장
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditApartmentModal;
